import { useContext } from "react";
import { DeliveryContext, AuthContext } from "@CONTEXTS";
import { Button, Tooltip, Menu, Dropdown, Modal, message } from "antd";
import { CopyElement } from "@UI";
import { moment } from "@LIBS";
import { Constants } from "@CONFIG";
import { deleteDelivery } from "@DELIVERIES";
import { ExclamationCircleOutlined } from "@ant-design/icons";

import { AiFillDelete, AiOutlineEdit, AiOutlineDown } from "react-icons/ai";
import { BiPackage } from "react-icons/bi";

const { confirm } = Modal;

const useLogics = ({ onLoading, onPrint }) => {
  const { mutate, dispatch, handlePackaged } = useContext(DeliveryContext);
  const { info } = useContext(AuthContext);

  const confirmDelete = async (id) => {
    if (!info.authorities.includes("DELIVERY_DELETE")) {
      return message.error("Gönderi silme yetkiniz bulunmamaktadır!");
    }
    confirm({
      title: "Silmek İstediğinize emin misiniz?",
      icon: <ExclamationCircleOutlined />,
      content:
        "Gönderiyi silmek istediğinizden emin misiniz? Onaylarsanız kalıcı olarak silinecektir. Devam etmek istiyor musunuz?",
      onOk() {
        return new Promise(async (resolve) => {
          onLoading(true);
          const response = await deleteDelivery(id);
          if (response) {
            mutate();
          }
          onLoading(false);
          resolve();
        });
      },
      onCancel() {},
    });
  };

  const menu = (record) => {
    return (
      <Menu>
        <Menu.Item
          key="5"
          icon={<BiPackage style={{ marginRight: 5 }} />}
          onClick={(e) => {
            e.domEvent.stopPropagation();
            if (!info.authorities.includes("DELIVERY_PACKAGE")) {
              return message.error(
                "Gönderi paketleme yetkiniz bulunmamaktadır!"
              );
            }
            handlePackaged({ record, onPrint });
          }}
        >
          Paketledim
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item
          key="2"
          icon={<AiOutlineEdit style={{ marginRight: 5 }} />}
          onClick={(e) => {
            e.domEvent.stopPropagation();
            dispatch({
              type: "SET_UPDATE_MODAL",
              payload: {
                title: `${record.barcode} - Gönderiyi Düzenle`,
                ...record,
              },
            });
          }}
        >
          Gönderiyi Düzenle
        </Menu.Item>
        <Menu.Item
          key="6"
          danger
          icon={<AiFillDelete style={{ marginRight: 5 }} />}
          onClick={(e) => {
            e.domEvent.stopPropagation();
            confirmDelete(record.id);
          }}
        >
          Gönderiyi Sil
        </Menu.Item>
      </Menu>
    );
  };

  const columns = [
    {
      title: "Barkod",
      key: "barcode",
      dataIndex: "barcode",
      width: 250,
      render: (data, record) => {
        return (
          <div className="big-text-container">
            <div className="big-text">
              <Tooltip title="Gönderi Detayı" placement="top">
                <Button
                  type="link"
                  style={{ padding: 0 }}
                  onClick={() =>
                    dispatch({
                      type: "SET_UPDATE_MODAL",
                      payload: {
                        title: `${record.barcode} - Gönderiyi Düzenle`,
                        ...record,
                      },
                    })
                  }
                >
                  {data}
                </Button>
              </Tooltip>
              <CopyElement text={data} />
            </div>
          </div>
        );
      },
    },
    {
      title: "Sipariş Numarası",
      key: "customerDeliveryNo",
      dataIndex: "customerDeliveryNo",
      width: 200,
    },
    {
      title: "Alıcı",
      key: "fullName",
      dataIndex: "fullName",
      width: 200,
      render: (_, record) =>
        `${record.recipient.firstName} ${record.recipient.lastName}`,
    },
    {
      title: "Alıcı Adresi",
      dataIndex: "address",
      key: "address",
      width: 200,
      render: (_, record) =>
        `${record.recipient.address?.town.name} / ${record.recipient.address?.city.name}`,
    },
    {
      title: "Eklenme Tarihi",
      key: ["meta", "createdOn"],
      dataIndex: ["meta", "createdOn"],
      width: 200,
      render: (data, record) => {
        if (record.meta?.updatedOn) {
          return (
            <>
              <div className="big-text">
                {moment(data).format(Constants.FORMATS.dateFormat)}
              </div>
              <div className="small-text">
                {moment(record.meta.updatedOn).format(
                  Constants.FORMATS.dateTimeFormat
                )}
              </div>
            </>
          );
        }
        return (
          <>
            <div className="big-text">
              {moment(data).format(Constants.FORMATS.dateFormat)}
            </div>
          </>
        );
      },
    },
    {
      title: "Gönderi Tipi",
      key: "deliveryType",
      dataIndex: "deliveryType",
      render: (_, record) => {
        return (
          <>
            {record?.deliveryType?.type === "TMH" && "XL TESLİMAT"}
            {record?.deliveryType?.type === "HX_STD" && "STANDART TESLİMAT"}
            {record?.deliveryType?.type === "HX_ND" && "ERTESİ GÜN TESLİMAT"}
            {record?.deliveryType?.type === "HX_SD" && "BUGÜN TESLİMAT"}
            {record?.deliveryType?.type === "POD" && "TAHSİLATLI GÖNDERİ"}
          </>
        );
      },
    },
    {
      title: "İşlemler",
      width: 80,
      render: (_, record) => (
        <Dropdown overlay={menu(record)} placement="bottomRight">
          <Button type="primary" size="small" block>
            <span>
              İşlemler <AiOutlineDown style={{ left: 5 }} />
            </span>
          </Button>
        </Dropdown>
      ),
    },
  ];

  const excelColumns = [];
  const searchKeys = [];
  return { columns, excelColumns, searchKeys };
};

export default useLogics;
